var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UtilHitCard',{attrs:{"type":"listing","layout":_vm.layout,"listing":_vm.compListingFromHit,"to":("/view/listing/" + (_vm.hit.slug) + "-" + (_vm.hit.objectID)),"showStatusTags":_vm.showStatusTags,"canWatch":_vm.canWatch}})}
var staticRenderFns = []

export { render, staticRenderFns }